import { create } from "zustand";

const useAlertStore = create((set) => ({
  isOpen: false,
  title: "",
  headline: "",
  callback: null,
  setIsOpen: (isOpen, title, headline, callback) => {
    set({ isOpen, title, headline, callback });
  },
}));

export default useAlertStore;
